// extracted by mini-css-extract-plugin
export var menuButton = "NavbarButton-module--menuButton--pWJDJ";
export var menuButtonBurger = "NavbarButton-module--menuButtonBurger--Xfif7";
export var toggled = "NavbarButton-module--toggled--2cR9S";